module.exports = __webpack_public_path__ + "static/media/4.f0469e0b.jpg";